import React, { Fragment, useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input,
    Button,
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import { t } from 'i18next';
import SuccessDialog from "../../Commons/SuccessDialog";
import { FORGOT_USERNAME } from '../../../store/actions/auth';
import FooterSignInPopup from "./FooterSignInPopup";
import MineError from "../../Commons/MineError";

export default function ForgotUsernamePopup(props) {
    const { id, portalId } = props
    const [error, setError] = useState('');
    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(false);
    const [show, setShow] = useState(true);

    const dispatch = useDispatch();

    const onChangeInput = (event) => {
        let { name, value } = event.target
        setEmail(value);
    }

    const onForgotUsername = async (event) => {
        setSuccess(false);
        let _err = '';
        if (!email) {
            _err = t(`MsgErrorEmail`)
        } else if (email.length < 3) {
            _err = t(`MsgErrorEmailMin3Char`)
        }
        setError(_err)
        if (_err) {
            return;
        }
        try {
            let result = await dispatch(FORGOT_USERNAME(portalId, email));
            if (result?.data?.code === 'EMAIL_NOT_FOUND') {
                setError(result.data.message);
            } else if (result?.status == 200) {
                setShow(false);
                setSuccess(true);
            }
        } catch (error) {
            _err = error.response && error.response.data && error.response.data.error && error.response.data.error.message ? error.response.data.error.message : error.message;
            setError(_err);
        }
    }

    const toggleModal = () => {
        setShow(!show)
        if (show && props.onHide) {
            props.onHide()
        }
    };

    return (
        <Fragment>
            <Modal id={id} isOpen={show} keyboard={true} centered>
                <ModalHeader toggle={toggleModal} className="text-left">{t('NavLinkForgotUsername')}</ModalHeader>
                <ModalBody>
                    <div className="row my-4 px-2" style={{ backgroundColor: '#f8f8f8', borderRadius: '0.5rem' }}>
                        <div className='col-12 text-center find-username-guide mt-4' >{t('TxtFindYourUsername')}</div>
                        <div className="col-12 d-flex align-items-center my-4">
                            <Input className="form-control me-2" type="text" id="forgotUsernameInput" placeholder={t('PlaceholderEmail')}
                                name="forgotUserNameEmail" value={email} required onChange={onChangeInput} style={{ height: '2.625rem' }} />
                            <Button type="button" className="btn btn-default rad-1" color="default" onClick={(e) => onForgotUsername(e)}>{t('CommonCode.BtnFind')}</Button>
                        </div>
                    </div>
                    {(error) ? <MineError message={error}></MineError> : null}
                    <br />
                </ModalBody>
                <ModalFooter>
                    <FooterSignInPopup></FooterSignInPopup>
                </ModalFooter>
            </Modal>

            {(success) ? (
                <SuccessDialog id={'dialog-forgot-username-success'} content={t('TxtForgotUsernameSuccess')} onHide={()=> (props.onHide && props.onHide())}></SuccessDialog>
            ) : null}
        </Fragment>
    );
}